export { useKanjiSelection } from './useKanjiSelection';
export type {
  KanjiSelection,
  KanjiSelectionActions,
} from './useKanjiSelection';

// Re-export types for convenience
export type { IKanjiObj } from '@/entities/kanji';
